<template>
  <div class="order-create__row custom-row">
    <div class="custom-col custom-col--50  custom-col--md-50 custom-col--sm-100"
         v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate([
      'apcDelcon_trackingNumber',
      ])"></div>
      <DefaultInput
          :label="$t('apcDelcon_trackingNumber.localization_value.value')"
          v-bind:class="{'ui-no-valid': APCD.validation.trackingNumber}"
          :errorTxt="$t(`${APCD.validationTranslate.trackingNumber}.localization_value.value`)"
          :error="APCD.validation.trackingNumber"
          v-model="APCD.data.trackingNumber"
      />
    </div>
    <div class="custom-col custom-col--50  custom-col--md-50 custom-col--sm-100"
         v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate([
      'apcDelcon_shippingCompany',
      ])"></div>
      <DefaultSelect
          :options="shippingCompanies"
          :optionsLabel="'name'"
          :label="$t('apcDelcon_shippingCompany.localization_value.value')"
          v-bind:class="{'ui-no-valid': APCD.validation.shippingCompany}"
          :errorTxt="$t(`${APCD.validationTranslate.shippingCompany}.localization_value.value`)"
          :error="APCD.validation.shippingCompany"
          @change="(val) => {APCD.setShippingCompany(val)}"
          :selected="APCD.data.shippingCompany"
      />
    </div>
  </div>
</template>

<script>
import DefaultInput from "../../../../UI/inputs/DefaultInput/DefaultInput";
import DefaultSelect from "../../../../UI/selectiones/DefaultSelect/DefaultSelect";

export default {
  name: "FieldsBlock",

  components: {
    DefaultSelect,
    DefaultInput
  },

  props: {
    APCD: Object,
    shippingCompanies: Array,
  }
}
</script>

<style scoped>

</style>